<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :large="large" :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon>
        <span>Importar {{ isAT ? "Atividades" : "Tarefas" }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon
              @click="
                () => {
                  dialog = false;
                  limpar();
                }
              "
              color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-select
              id="solution-select"
              v-model="payload.solucao"
              item-text="nome"
              item-value="municipioSolucaoId"
              :items="solutionList"
              :label="`${isAT ? 'Iniciativas' : 'Solução'}`"
              :placeholder="`${isAT ? 'Iniciativas' : 'Solução'}`"
              :return-object="true"
              @change="changeSolution"
            >
              <template slot="no-data">
                Nenhuma {{ isAT ? "atividade" : "tarefa" }} retornada
              </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <task-combobox
              :filter="payload"
              :itens="tarefas"
              @onChange="teste"
            ></task-combobox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="error"
          outlined
          text
          @click="
            () => {
              dialog = false;
              limpar();
            }
          "
          >Fechar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="onConfirm"
          :disabled="
            !payload.solucao.municipioSolucaoId || !payload.solucao.tarefas
          "
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityTaskAPI, citySolutionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import { taskAPI } from "@/modules/task";
import TaskCombobox from "@/modules/task/components/city/Combobox";
import { compare } from "@/helpers/orderByAsc";

export default {
  name: "AppModalImportGroupSolution",
  components: {
    TaskCombobox,
  },
  props: {
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    filter: {},
  },

  data() {
    return {
      payload: {
        municipioId: this.$route.params.id,
        solucao: {
          tarefas: [],
        },
      },
      dialog: false,
      solutionList: [],
      tarefas: [],
    };
  },
  computed: {
    ...mapGetters(["user", "isAT"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    limpar() {
      this.payload = {};
      this.payload.municipioId = this.$route.params.id;
      this.payload.solucao = { tarefas: [] };
      this.$forceUpdate();
    },
    onConfirm() {
      this.setLoading(true);
      cityTaskAPI
        .addBySolucao(this.payload)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success(
            `${this.isAT ? "Atividades" : "Tarefas"} incluídas com sucesso`
          );
          this.limpar();
          this.dialog = false;
          this.$emit("onSave");
          this.getSolutions();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao incluir ${this.isAT ? "atividades" : "tarefas"}`
          );
        });
    },

    changeSolution() {
      this.setLoading(true);
      this.payload.solucao.tarefas = [];
      if (this.payload.solucao.tarefas.length > 0) {
        this.payload.solucao.tarefas = this.payload.solucao.tarefas.filter(
          (item) => item.desabilitado == false
        );
      }
      taskAPI
        .getBySolucao(this.payload.solucao)
        .then((resp) => {
          this.tarefas = resp.data.sort((a, b) => compare(a, b, "nome"));
          this.payload.municipioSolucaoId =
            this.payload.solucao.municipioSolucaoId;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao obter ${this.isAT ? "atividades" : "tarefas"}`
          );
        });
    },
    getSolutions() {
      this.setLoading(true);

      var filtro = {
        municipioId: this.$route.params.id,
        grupoSolucaoId:
          this.filter.municipioGrupoSolucao &&
          this.filter.municipioGrupoSolucao.municipioGrupoSolucaoId,
        municipioId: this.$route.params.id,
      };
      citySolutionAPI
        .listByCity(filtro)
        .then((resp) => {
          this.solutionList = resp.data
            .sort((a, b) => compare(a, b, "nome"))
            .filter((item) => item.solucaoId != null);
          this.setLoading(false);
        })
        .catch();
    },
    teste(val) {
      this.payload.solucao.tarefas = val;
    },
  },
  watch: {
    dialog(val) {
      if (val) this.getSolutions();
    },
  },
};
</script>
